import { faArrowDownWideShort, faArrowUpShortWide } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TrainingPanelOrderDirection } from "generated/CoreApi_v1";
import { useTranslation } from "react-i18next";

interface IProps {
    direction: TrainingPanelOrderDirection;
}
export const DashboardOrderDirection = ({ direction }: IProps) => {
    const { t } = useTranslation("shared");
    return <FontAwesomeIcon
        icon={direction == TrainingPanelOrderDirection.Ascending ? faArrowUpShortWide : faArrowDownWideShort}
        title={direction == TrainingPanelOrderDirection.Ascending ? t("SortDirection.Ascending") : t("SortDirection.Descending")}
        size="2x"
    />;
};
